(() => {
  const initWellnessCoach = (root) => {
    if (!root || root.dataset.wellnessCoachInitialized === 'true') return;
    root.dataset.wellnessCoachInitialized = 'true';

    const updateBilling = (card, billing) => {
      const billingButtons = Array.from(card.querySelectorAll('[data-wc-billing]'));

      card.classList.toggle('is-yearly', billing === 'yearly');
      card.classList.toggle('is-monthly', billing === 'monthly');

      billingButtons.forEach((button) => {
        const isActive = button.dataset.wcBilling === billing;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      const priceContainer = card.querySelector('.wellness-coach_price-con');
      if (priceContainer && billingButtons.length) {
        const priceContents = Array.from(priceContainer.querySelectorAll('[data-wc-price-content]'));
        const activePriceContent = priceContents.find((content) => content.dataset.wcPriceContent === billing);
        const defaultPriceContent = priceContainer.querySelector('[data-wc-default-price]');

        priceContents.forEach((content) => {
          content.hidden = content !== activePriceContent;
        });

        if (defaultPriceContent) {
          defaultPriceContent.hidden = Boolean(activePriceContent);
        }
      }

      const actionButton = card.querySelector('a[data-wc-button]');
      if (actionButton) {
        const nextUrl = billing === 'yearly'
          ? actionButton.dataset.wcButtonYearlyUrl
          : actionButton.dataset.wcButtonMonthlyUrl;

        if (nextUrl) {
          actionButton.setAttribute('href', nextUrl);
        }
      }
    };

    const setCardHighlight = (card, isHighlighted) => {
      card.classList.toggle('is-highlighted', isHighlighted);
      card.classList.toggle('is-hightlight', isHighlighted);
    };

    root.addEventListener('click', (event) => {
      const billingButton = event.target.closest('[data-wc-billing]');
      if (billingButton && root.contains(billingButton)) {
        const card = billingButton.closest('[data-wc-card]');
        if (card) {
          updateBilling(card, billingButton.dataset.wcBilling || 'monthly');
        }
        return;
      }

      const clickedCard = event.target.closest('[data-wc-card]');
      if (!clickedCard || !root.contains(clickedCard)) return;

      const interactiveTarget = event.target.closest('a, button, input, select, textarea, label, summary');
      if (interactiveTarget && clickedCard.contains(interactiveTarget)) return;

      const isHighlighted = clickedCard.classList.contains('is-highlighted') || clickedCard.classList.contains('is-hightlight');
      setCardHighlight(clickedCard, !isHighlighted);
    });

    root.querySelectorAll('[data-wc-card]').forEach((card) => {
      if (card.classList.contains('is-highlighted') || card.classList.contains('is-hightlight')) {
        setCardHighlight(card, true);
      }
    });

    root.querySelectorAll('[data-wc-card]').forEach((card) => {
      updateBilling(card, card.dataset.wcDefaultBilling || 'monthly');
    });
  };

  const init = () => {
    document.querySelectorAll('[data-wellness-coach]').forEach((root) => {
      if (window.elToObserver) {
        window.elToObserver(root, () => initWellnessCoach(root));
      } else {
        initWellnessCoach(root);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-wellness-coach]').forEach((root) => {
      if (window.elToObserver) {
        window.elToObserver(root, () => initWellnessCoach(root));
      } else {
        initWellnessCoach(root);
      }
    });
  });
})();
